import React from "react";
import Modal from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import styled from "styled-components";
import "../../styles/CustomModal.css";

const ConfirmModal = (oProps: {
  isVisible: boolean;
  setVisible: any;
  title: string;
  cancelText?: string;
  confirmText: string;
  onConfirm?: any;
}) => {
  const onCloseModal = () => {
    oProps.setVisible(false);
  };

  return (
    <Modal
      open={oProps.isVisible}
      onClose={onCloseModal}
      center
      classNames={{
        overlay: "optionCustomOverlay",
        modal: "confirmModal",
      }}
      closeOnOverlayClick={false}
      showCloseIcon={false}
      animationDuration={150}
    >
      <Style>
        <div className="modal">
          <img
            className="closeIcon"
            onClick={onCloseModal}
            src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_close.svg`}
            alt="ic"
          />

          <p className={`titleFont ${!oProps.cancelText && "gap"}`}>
            {oProps.title}
          </p>

          <div className="bottomButtonWrap">
            {oProps.cancelText && (
              <div className="cancelButton" onClick={onCloseModal}>
                {oProps.cancelText}
              </div>
            )}
            <div
              className="confirmButton"
              onClick={oProps.onConfirm ? oProps.onConfirm : onCloseModal}
            >
              {oProps.confirmText}
            </div>
          </div>
        </div>
      </Style>
    </Modal>
  );
};

export default ConfirmModal;

const Style = styled.div`
  .modal {
    width: 100%;
  }

  .closeIcon {
    position: absolute;
    top: 5%;
    right: 4%;
    cursor: pointer;
  }

  .titleFont {
    padding: 77px 0;
    font-size: 24px;
    line-height: 43px;
    font-weight: 500;
    color: #000000;
    text-align: center;
  }

  .bottomButtonWrap {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;

    .cancelButton {
      width: 100%;
      padding: 16px;
      font-size: 24px;
      line-height: 32px;
      border-radius: 10px;
      font-weight: 600;
      text-align: center;
      cursor: pointer;
      color: #ff616b;
      background: #ffffff;
      border: 1px solid #ff616b;
    }

    .confirmButton {
      width: 100%;
      padding: 16px;
      font-size: 24px;
      line-height: 32px;
      border-radius: 10px;
      font-weight: 600;
      text-align: center;
      cursor: pointer;
      color: #ffffff;
      background: #4dd2ae;
      border: 1px solid #4dd2ae;
    }
  }
`;
